<template>
  <div class="wrapper bg-grey-lightest">
    <div class="title">Payment</div>
    <div class="content">
      Payment information not found, please create account
      <a
        :href="
          'https://connect.stripe.com/express/oauth/authorize?redirect_uri=' +
          basicUrl +
          'stripe&client_id=' +
          stripeClientId +
          '&state=EWIF'
        "
        target="_blank"
        >here</a
      >
      or contact
      <a :href="'mailto:' + email" target="_blank">{{ email }}</a> to link your
      account.
    </div>
    <img class="image" src="@/assets/image/payment.svg" alt="" />
  </div>
</template>

<script>
import * as config from "@/config";
export default {
  data() {
    return {
      basicUrl: config.BASIC_URL,
      email: config.DEFAULT_CONTACT_EMAIL,
      stripeClientId: config.STRIPE_CLIENT_ID,
    };
  },
};
</script>

<style scoped>
.wrapper {
  flex-grow: 1;
}
.title {
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  color: #1c1c1c;
  margin: 66px 0 0 44px;
  font-family: inter-regular;
}
.content {
  font-family: inter-regular;
  max-width: 732px;
  text-align: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #1c1c1c;
  margin: 80px auto 24px;
}
.image {
  display: block;
  margin: 0 auto;
}
</style>
